export default __webpack_public_path__ + "static/images/blackpink_03.png";